module.exports = __webpack_public_path__ + "img/bank-020.0222c4bf.png";